import React from 'react'
import "./page.css"
import Telegram_icon from "../assets/telegram_btn.png"
import whatsapp_btn from "../assets/whatsapp_btn.png"
import { Link } from 'react-router-dom'
import ArrowLeft from "../assets/left-icon.png"
import RewardsIcon from "../assets/rewards-icon.png"


export default function ContactUs() {
  return (
    <div>
      <div className='rewards_section'>
        <div className='container'>
          <div className='rewards_heading'>
            <img src={RewardsIcon} />
            <p>Book Now & Earn Rewards</p>
          </div>
        </div>
      </div>

      <div className='inner_title_section'>
        <div className='container'>
          <div className='inner_title_flex'>
            <Link to='/booking'>
              <img src={ArrowLeft} />
            </Link>
            <h3>Customer Service</h3>
          </div>
        </div>
      </div>

      <div className='contact_section'>
        <div className='container'>
          <div className='contact_inner'>
            <h2>Choose Your Services</h2>
            <div className='contact_soical_btn'>
              <Link to='https://t.me/SofitelOnlineCustomerSupport' component="a" target="_blank" rel="noopener noreferrer"><img src={Telegram_icon} /></Link>
              <Link to='https://web.whatsapp.com/' component="a" target="_blank" rel="noopener noreferrer"><img src={whatsapp_btn} /></Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
